"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useClient = _interopRequireDefault(require("./useClient"));

var _clients = require("../../constants/clients");

var useClaims = function useClaims(_ref) {
  var queryParameters = _ref.queryParameters,
      environment = _ref.environment,
      accessToken = _ref.accessToken;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoadingClaims = _useState2[0],
      setIsLoadingClaims = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      claims = _useState4[0],
      setClaims = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var claimsClient = (0, _useClient["default"])({
    environment: environment,
    accessToken: accessToken,
    clientType: _clients.FULFILLER_CLAIMS
  }); // If the client or query parameters change, fetch the latest claims

  (0, _react.useEffect)(function () {
    var refreshClaimList =
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var _ref3, newClaims, newError;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return claimsClient.getClaims(queryParameters);

              case 2:
                _ref3 = _context.sent;
                newClaims = _ref3.claims;
                newError = _ref3.error;

                if (!claimsClient.isCancelled()) {
                  setClaims(newClaims);
                  setError(newError);
                  setIsLoadingClaims(false);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function refreshClaimList() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (claimsClient) {
      setIsLoadingClaims(true);
      refreshClaimList();
    }
  }, [claimsClient, queryParameters]);
  return {
    isLoadingClaims: isLoadingClaims,
    claims: claims,
    error: error
  };
};

var _default = useClaims;
exports["default"] = _default;